"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require("reactstrap");

var _kpiwidget = require("./kpiwidget");

var _kpiwidget2 = _interopRequireDefault(_kpiwidget);

var _lodash = require("lodash");

var _formatters = require("./formatters.js");

var _labels = require("./labels.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import numeral from "numeral";


var KPIWidgetGenerator = function (_Component) {
  _inherits(KPIWidgetGenerator, _Component);

  function KPIWidgetGenerator() {
    _classCallCheck(this, KPIWidgetGenerator);

    return _possibleConstructorReturn(this, (KPIWidgetGenerator.__proto__ || Object.getPrototypeOf(KPIWidgetGenerator)).apply(this, arguments));
  }

  _createClass(KPIWidgetGenerator, [{
    key: "render",
    value: function render() {
      var props = this.props;

      var _props$widgetselectio = _extends({}, props.widgetselections),
          measure = _props$widgetselectio.measure,
          geographytype = _props$widgetselectio.geographytype,
          geographyvalue = _props$widgetselectio.geographyvalue;

      var kpidataarray = props.data;
      var title = props.title;
      var widget = [];

      kpidataarray.map(function (datarecord, index) {
        measure.split(",").map(function (measurerecord) {
          if (typeof _formatters.formatter[measurerecord] === "function") {
            _formatters.formatter[measurerecord].apply(datarecord);
          }
          var widgetselections = {
            geographytype: datarecord.GeographyType,
            geographyvalue: datarecord.GeographyName,
            measure: measurerecord,
            measurelabel: _labels.labels[measurerecord],
            measuredata: typeof _formatters.formatter[measurerecord] === "function" ? _formatters.formatter[measurerecord].apply(datarecord) : datarecord["" + measurerecord]
          };

          widget.push(_react2.default.createElement(_kpiwidget2.default, { key: (0, _lodash.uniqueId)(), widgetselections: widgetselections, title: title }));
        });
      });

      return _react2.default.createElement(
        "div",
        { key: (0, _lodash.uniqueId)('kpiCardColumns-') },
        widget
      );
    }
  }]);

  return KPIWidgetGenerator;
}(_react.Component);

exports.default = KPIWidgetGenerator;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/widget.js
// module id = 217
// module chunks = 0